export const rewriteUrl = (
  identifier: string,
  relative: boolean = false,
): string => {
  const PEBBLE_NEWS_VIEWER = `api/v1/news/article/`;
  const host = relative && import.meta.env.DEV ? "" : "https://pebble.finance";

  // Already-absolute http(s) URLs: pass through unchanged (the callers
  // upstream may do domain stripping in relative/DEV mode).
  if (identifier.includes("api/v1/news/article/")) {
    // Strip the domain if relative is requested
    if (relative && import.meta.env.DEV && identifier.startsWith("https://")) {
      return identifier.replace(/^https?:\/\/[^/]+\//, "/");
    }
    return identifier;
  }

  // Check for provider-specific format: api/v1/news/providers/{provider}/uuid/
  if (
    identifier.includes("api/v1/news/providers/") &&
    identifier.includes("/uuid/")
  ) {
    // Strip the domain if relative is requested
    if (relative && import.meta.env.DEV && identifier.startsWith("https://")) {
      return identifier.replace(/^https?:\/\/[^/]+\//, "/");
    }
    return identifier;
  }

  // Already-rooted path-style URLs (e.g. `/news/article/<uuid>`): treat as a
  // client-side path and pass through.
  if (identifier.startsWith("/")) {
    return identifier;
  }

  // Fallback: assume it's a UUID and use the new format
  return `${host}/${PEBBLE_NEWS_VIEWER}${identifier}`;
};
